/**
 * regenerateScreenshotMetadataField
 *
 * @description Regenerates one screenshot metadata field with context from the active flow.
 * @param {Props} props - Active media/service context and regeneration callback.
 * @param {RegenerateScreenshotMetadataFieldInput["field"]} props.field - Field to regenerate.
 * @param {string} props.originalUrl - Screenshot source URL.
 * @returns {ReturnType<RegenerateScreenshotMetadataField>} Regenerated field value when available.
 *
 */
const regenerateScreenshotMetadataField = async ({ contentId, field, id, mediaType, newsName, newsIMDbId, newsReleaseDate, onRegenerateMetadataField, originalUrl, reviewName, reviewIMDbId, serviceType }) => {
    if (mediaType !== "screenshots") {
        return undefined;
    }
    if (serviceType === "news") {
        return await onRegenerateMetadataField({
            contentId,
            field,
            id,
            imdbId: newsIMDbId ?? undefined,
            originalUrl,
            releaseDate: newsReleaseDate ?? undefined,
            title: newsName ?? undefined
        });
    }
    return await onRegenerateMetadataField({
        contentId,
        field,
        id,
        imdbId: reviewIMDbId ?? undefined,
        originalUrl,
        title: reviewName ?? undefined
    });
};
export default regenerateScreenshotMetadataField;
